import { createModalProvider } from "~components/shared/ModalContext/ModalContext";

import { PositionErrorModal } from "./PositionErrorModal";

export const {
  provider: PositionErrorModalProvider,
  hook: usePositionErrorModal,
} = createModalProvider(PositionErrorModal);
